"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (value) {
    return (+value).toFixed(2);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/number/toMoney.js
// module id = 107
// module chunks = 0